import axios from "axios";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../../utils/queryParams.js";
import { paramsToString } from "../../../../helpers/parseToString";

export const FETCH_HEATMAP_DATA = "saga/FETCH_HEATMAP_DATA";
export const FETCH_HEATMAP_DATA_SUCCESS = "saga/FETCH_HEATMAP_DATA_SUCCESS";
export const FETCH_HEATMAP_DATA_FAILURE = "saga/FETCH_HEATMAP_DATA_FAILURE";
export const FETCH_FILTERS_SUCCESS = "saga/FETCH_FILTERS_SUCCESS";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const UPDATE_SECONDARY_CATEGORY = "saga/UPDATE_SECONDARY_CATEGORY";
export const UPDATE_HEATMAP_DATA = "saga/UPDATE_HEATMAP_DATA";
export const SET_LOADING = "saga/SET_LOADING";
export const SET_FILTERS_DIRTY = "saga/SET_FILTERS_DIRTY";
export const RESET_FILTERS = "saga/RESET_FILTER";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  fetchHeatmapData: createAction(FETCH_HEATMAP_DATA),
  updateSecondaryCategory: createAction(UPDATE_SECONDARY_CATEGORY),
  updateHeatmapData: createAction(UPDATE_HEATMAP_DATA),
  resetFilters: createAction(RESET_FILTERS)
};

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(FETCH_HEATMAP_DATA, getHeatmapData);
  yield takeLatest(UPDATE_HEATMAP_DATA, updateHeatmapData);
  yield takeLatest(RESET_FILTERS, resetFilters);
}

function* getCommonApiParams() {
  return yield select((state) => {
    let params = [
      state.currentUser.organization_id,
      state.currentUser.current_location_id,
      state.currentUser.current_object_id
    ];
    return params.map((param) => param.toString());
  });
}

export function* fetchCurrentUserData(data) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: { currentUser: data.payload }
  });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  try {
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getHeatmapData({ payload }) {
  try {
    yield put({ type: SET_LOADING, payload: true });
    if (payload.sourceType === "clubready" && !payload.update) {
      yield fetchFilters(payload);
    }
    const { selectedSecondaryCategories } = yield select((state) => state);
    const values = selectedSecondaryCategories.length
      ? selectedSecondaryCategories.map((p) => p.id).join(",")
      : "";

    const res = yield call(
      axios.get,
      queryParams.apiVersion +
        "pages/memberships/membership_retention_heatmap" +
        "?organization_id=" +
        payload.organizationId +
        "&location_id=" +
        payload.locationId +
        "&object_id=" +
        payload.objectId +
        (values ? `&secondary_categories=${values} ` : "") +
        (payload?.categories && payload.categories.length
          ? "&categories=" + paramsToString(payload.categories)
          : "") +
        (payload?.classPass ? "&class_pass=" + payload.classPass : "") +
        (payload?.numbersOrPercentages
          ? "&numbers_or_percentages=" + payload.numbersOrPercentages
          : "")
    );

    // TODO: this is correction from snake case to camel case, remove on backend fix
    const filters = res.data.filters;
    if (filters && filters.class_pass) {
      res.data.filters = {
        tooltip: filters.tooltip,
        classPass: filters.class_pass,
        numbersOrPercentages: filters.numbers_or_percentages,
        classPasses: filters.class_passess
      };
    }

    yield put({ type: FETCH_HEATMAP_DATA_SUCCESS, payload: res.data });
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_HEATMAP_DATA_FAILURE, error });
  }
}

export function* updateHeatmapData() {
  const sagaArguments = yield getCommonApiParams();
  const [organizationId, locationId, objectId] = sagaArguments;
  const { filters } = yield select((state) => state);
  const payload = { ...filters, organizationId, locationId, objectId };

  yield getHeatmapData({ payload, update: true });
}

function* resetFilters() {
  yield put({ type: SET_LOADING, payload: true });
  try {
    yield updateHeatmapData();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* fetchFilters(params) {
  const { organizationId, locationId, objectId } = params;
  if (!organizationId || !locationId || !objectId) {
    return;
  }

  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion +
        "pages/memberships/membership_retention_heatmap/get_filters" +
        "?organization_id=" +
        organizationId +
        "&location_id=" +
        locationId +
        "&object_id=" +
        objectId
    );

    yield put({ type: FETCH_FILTERS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
  }
}
